module.exports = __webpack_public_path__ + "static/media/filename (16).2d42d8b5.png";